export default __webpack_public_path__ + "static/media/cecresul-logo.20b6522a.png";